import serverApi from "../utils/serverApi";

const eventsService = {

    getEvents: (data) => serverApi({ uri: "events?platform=web", data, method: "GET" }),

    getActiveEvents: () => serverApi({ uri: `events/active?platform=web`, method: "GET", isLoading: false }),

    getEventDetail: (uuid, isLoading = true) => serverApi({ uri: `events/${uuid}`, method: "GET", isLoading }),

    getEventPrizes: (eventId, isLoading = false) => serverApi({ uri: `events/${eventId}/prizes`, method: "GET", isLoading }),

    getInvitedFriends: (uuid, isLoading = true) => serverApi({ uri: `events/${uuid}/invited-friends`, method: "GET", isLoading }),
};

export default eventsService;
